'use client';

import { createContext, useContext, useEffect, useSyncExternalStore, type ReactNode } from 'react';
import { createMicrophoneTestController } from './microphoneTestController';

const MicrophoneContext = createContext<ReturnType<typeof createMicrophoneTestController> | null>(null);

export function MicrophoneTestProvider({ children, controller }: {
    children: ReactNode; controller: ReturnType<typeof createMicrophoneTestController>;
}) {
    useEffect(() => {
        controller.check();
        const pagehide = () => controller.dispose();
        window.addEventListener('pagehide', pagehide);
        return () => {
            window.removeEventListener('pagehide', pagehide);
            controller.dispose();
        };
    }, [controller]);
    return <MicrophoneContext.Provider value={controller}>{children}</MicrophoneContext.Provider>;
}

export function useMicrophoneTest() {
    const controller = useContext(MicrophoneContext);
    if (!controller) throw new Error('Microphone test requires MicrophoneTestProvider.');
    const state = useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getServerSnapshot);
    return { controller, state };
}
